import { createContext } from 'react'

export const EmailProfileActionsContext = createContext()
